import { CHANNEL_TYPES, PROVIDER_TYPES } from '../../vars/general'

export type ChannelGroupKey = 'whatsapp' | 'telegram' | 'max' | 'maxBusiness' | 'sms'

type ProviderOption = {
    id: string
    name: string
}

const GROUP_OPTIONS: Record<ChannelGroupKey, ProviderOption[]> = {
    whatsapp: [
        { id: PROVIDER_TYPES.whatsappBasis, name: 'Провайдер 1' },
        { id: PROVIDER_TYPES.whatsappApi, name: 'Провайдер 2' },
        { id: PROVIDER_TYPES.whatsappDh, name: 'Провайдер 3' },
        // Легаси-провайдер 'whatsapp' (старый DH-бот) скрыт из подключения — миграция на dh-whatsapp завершена.
    ],
    // Provider 1 (telegramApi) is deprecated and no longer offered for selection.
    // Legacy telegramApi channels still display/migrate, but new channels are dh only.
    telegram: [{ id: PROVIDER_TYPES.telegramDh, name: 'Telegram' }],
    max: [
        { id: PROVIDER_TYPES.maxBasis, name: 'Провайдер 1' },
        { id: PROVIDER_TYPES.maxDh, name: 'Провайдер 2' },
    ],
    maxBusiness: [{ id: PROVIDER_TYPES.maxBusiness, name: 'MAX Business' }],
    sms: [{ id: PROVIDER_TYPES.smsGate, name: 'SMS' }],
}

const PROVIDER_BASE_NAMES: Record<string, string> = {
    [PROVIDER_TYPES.whatsappBasis]: 'WhatsApp',
    [PROVIDER_TYPES.whatsappApi]: 'WhatsApp',
    [PROVIDER_TYPES.whatsapp]: 'WhatsApp',
    [PROVIDER_TYPES.whatsappDh]: 'WhatsApp',
    [PROVIDER_TYPES.telegramApi]: 'Telegram',
    [PROVIDER_TYPES.telegramDh]: 'Telegram',
    [PROVIDER_TYPES.maxBasis]: 'MAX',
    [PROVIDER_TYPES.maxDh]: 'MAX',
    [PROVIDER_TYPES.maxBusiness]: 'MAX Business',
    [PROVIDER_TYPES.smsGate]: 'SMS',
}

const PROVIDER_TO_GROUP: Record<string, ChannelGroupKey> = {
    [PROVIDER_TYPES.whatsappBasis]: 'whatsapp',
    [PROVIDER_TYPES.whatsappApi]: 'whatsapp',
    [PROVIDER_TYPES.whatsapp]: 'whatsapp',
    [PROVIDER_TYPES.whatsappDh]: 'whatsapp',
    [PROVIDER_TYPES.telegramApi]: 'telegram',
    [PROVIDER_TYPES.telegramDh]: 'telegram',
    [PROVIDER_TYPES.maxBasis]: 'max',
    [PROVIDER_TYPES.maxDh]: 'max',
    [PROVIDER_TYPES.maxBusiness]: 'maxBusiness',
    [PROVIDER_TYPES.smsGate]: 'sms',
}

const CHANNEL_TYPE_TO_GROUP: Record<string, ChannelGroupKey> = {
    [CHANNEL_TYPES.whatsappChannel]: 'whatsapp',
    [CHANNEL_TYPES.telegramChannel]: 'telegram',
    [CHANNEL_TYPES.maxChannel]: 'max',
    [CHANNEL_TYPES.maxBusiness]: 'maxBusiness',
    [CHANNEL_TYPES.smsChannel]: 'sms',
}

const GROUP_DEFAULT_PROVIDER: Record<ChannelGroupKey, string> = {
    // Дефолт WhatsApp — наше self-hosted решение (dh-whatsapp)
    whatsapp: PROVIDER_TYPES.whatsappDh,
    telegram: PROVIDER_TYPES.telegramDh,
    // Дефолт MAX — наше self-hosted решение (dh-max, «Провайдер 2»)
    max: PROVIDER_TYPES.maxDh,
    maxBusiness: PROVIDER_TYPES.maxBusiness,
    sms: PROVIDER_TYPES.smsGate,
}

export function getProviderOptionsByGroup(group?: string): ProviderOption[] {
    if (!group) return []
    return GROUP_OPTIONS[group as ChannelGroupKey] || []
}

export function getChannelBaseNameByProviderType(providerType?: string): string {
    if (!providerType) return 'Channel'
    return PROVIDER_BASE_NAMES[providerType] || 'Channel'
}

export function getChannelGroupByProviderType(
    providerType?: string
): ChannelGroupKey | null {
    if (!providerType) return null
    return PROVIDER_TO_GROUP[providerType] || null
}

export function getChannelGroupByChannelType(
    channelType?: string
): ChannelGroupKey | null {
    if (!channelType) return null
    return CHANNEL_TYPE_TO_GROUP[channelType] || null
}

export function getDefaultProviderTypeForGroup(group?: string): string | null {
    if (!group) return null
    return GROUP_DEFAULT_PROVIDER[group as ChannelGroupKey] || null
}

export function getProjectChannelGroups() {
    return [
        {
            name: 'whatsapp',
            channelTypes: [PROVIDER_TYPES.whatsappDh, PROVIDER_TYPES.whatsappApi, PROVIDER_TYPES.whatsapp],
            defaultType: PROVIDER_TYPES.whatsappDh,
            channelConnectorType: CHANNEL_TYPES.whatsappChannel,
            displayName: 'WhatsApp',
        },
        {
            name: 'telegram',
            channelTypes: [PROVIDER_TYPES.telegramDh],
            defaultType: PROVIDER_TYPES.telegramDh,
            channelConnectorType: CHANNEL_TYPES.telegramChannel,
            displayName: 'Telegram',
        },
        {
            name: 'max',
            channelTypes: [PROVIDER_TYPES.maxDh, PROVIDER_TYPES.maxBasis],
            defaultType: PROVIDER_TYPES.maxDh,
            channelConnectorType: CHANNEL_TYPES.maxChannel,
            displayName: 'MAX',
        },
        {
            name: 'maxBusiness',
            channelTypes: [PROVIDER_TYPES.maxBusiness],
            defaultType: PROVIDER_TYPES.maxBusiness,
            channelConnectorType: CHANNEL_TYPES.maxBusiness,
            displayName: 'MAX Business',
        },
        {
            name: 'sms',
            channelTypes: [PROVIDER_TYPES.smsGate],
            defaultType: PROVIDER_TYPES.smsGate,
            channelConnectorType: CHANNEL_TYPES.smsChannel,
            displayName: 'SMS',
        },
    ]
}

export function isMessagingChannelType(connectorType?: string): boolean {
    if (!connectorType) return false
    return Object.values(CHANNEL_TYPES).includes(connectorType as any)
}
